import { call, put, takeLatest } from 'redux-saga/effects';
import { fileService } from './file.service';
import { httpRequestsOnErrorsActions } from '../http_requests_on_errors';
import { httpRequestsOnLoadActions } from '../http_requests_on_load';
import { ADD_FILE, ARCHIVE_FILES, DELETE_FILES, EDIT_FILE, GET_FILES, GET_FILES_SUCCESS, SHARE_FILE, UN_SHARE_FILE } from './file.type';
import { toast } from 'react-toastify';
import { NotError } from '../../components';
import React from 'react';
import { httpRequestsOnSuccessActions } from '../http_requests_on_success';

function* getFiles(action) {
    if (action?.payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    }
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    try {
        const res = yield call(fileService.getFilesService, action.payload?.params);
        yield put({
            type: GET_FILES_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        yield put({
            type: GET_FILES_SUCCESS,
            payload: [],
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        if (err?.data?.message === 'Internal server error') {
            yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
        }
    }
}

function* addFile(action) {
    if (action?.payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    }
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(fileService.addFileService, action.payload?.params, action.payload?.body);

        const res = yield call(fileService.getFilesService, action.payload?.params);
        yield put({
            type: GET_FILES_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    }
}

function* editFile(action) {
    if (action?.payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    }
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    try {
        yield call(fileService.editFileService, action.payload?.params, action.payload?.id, action.payload?.body);
        const res = yield call(fileService.getFilesService, action.payload?.params);
        yield put({
            type: GET_FILES_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    }
}
function* deleteFiles(action) {
    if (action?.payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    }
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    try {
        yield call(fileService.deleteFilesService, action.payload?.params, action.payload?.docIds);
        const res = yield call(fileService.getFilesService, action.payload?.params);
        yield put({
            type: GET_FILES_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    }
}
function* archiveFiles(action) {
    if (action?.payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    }
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    try {
        yield call(fileService.archiveFilesService, action.payload?.params, action.payload?.docIds);
        const res = yield call(fileService.getFilesService, action.payload?.params);
        yield put({
            type: GET_FILES_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    }
}
function* shareFile(action) {
    if (action?.payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    }
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    try {
        yield call(fileService.shareFileService, action.payload?.resourceId, action.payload?.fileId, action?.payload?.body);
        const res = yield call(fileService.getFilesService, action.payload?.params);
        yield put({
            type: GET_FILES_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    }
}
function* unShareFile(action) {
    if (action?.payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    }
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    try {
        yield call(fileService.unShareFileService, action.payload?.resourceId, action.payload?.fileId);
        const res = yield call(fileService.getFilesService, action.payload?.params);
        yield put({
            type: GET_FILES_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    }
}

export const watchFiles = function* watchFileSaga() {
    yield takeLatest(GET_FILES, getFiles);
    yield takeLatest(ADD_FILE, addFile);
    yield takeLatest(EDIT_FILE, editFile);
    yield takeLatest(DELETE_FILES, deleteFiles);
    yield takeLatest(ARCHIVE_FILES, archiveFiles);
    yield takeLatest(SHARE_FILE, shareFile);
    yield takeLatest(UN_SHARE_FILE, unShareFile);
};
